export default "__VITE_ASSET__BRozwBwU__"